import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Zendesk, { ZendeskAPI } from 'react-zendesk';

import { zendeskLoaded, zendeskLoginUser } from '../../actions';
import ZendeskTokenAPI from '../../api/ZendeskTokenAPI';
import { accessTokenSelector, customerGuidSelector, emailSelector } from '../../reducers/selectors';

const {
  REACT_APP_ZENDESK_ENABLE_LIVE_CHAT: ZENDESK_ENABLE_LIVE_CHAT,
  REACT_APP_ZENDESK_KEY: ZENDESK_KEY,
} = process.env;

const NISOZendesk = ({
  accessToken,
  customerGuid,
  email,
  dispatchZendeskLoaded,
  dispatchZendeskLoginUser,
}) => {
  if (!customerGuid || email === '') {
    return null;
  }

  const settings = {
    webWidget: {
      helpCenter: {
        filter: {
          label: ['student loan', 'repayment'],
        },
        searchPlaceholder: {
          '*': 'Search our Help Centre',
        },
      },
      chat: {
        suppress: ZENDESK_ENABLE_LIVE_CHAT !== '1',
        connectOnPageLoad: false,
        tags: ['niso'],
        departments: {
          select: 'Student Loan',
        },
      },
      authenticate: {
        chat: {
          jwtFn: async callback => {
            const { widgetToken } = await ZendeskTokenAPI.getZendeskToken(
              customerGuid,
              accessToken,
              email,
            );
            callback(widgetToken);
          },
        },
      },
    },
  };

  const onLoaded = async () => {
    ZendeskAPI('webWidget', 'setLocale', 'en');
    dispatchZendeskLoginUser();

    dispatchZendeskLoaded();
  };

  return <Zendesk zendeskKey={ZENDESK_KEY} {...settings} onLoaded={onLoaded} />;
};

NISOZendesk.propTypes = {
  accessToken: PropTypes.string.isRequired,
  customerGuid: PropTypes.string,
  email: PropTypes.string,
  dispatchZendeskLoaded: PropTypes.func.isRequired,
  dispatchZendeskLoginUser: PropTypes.func.isRequired,
};

NISOZendesk.defaultProps = {
  customerGuid: null,
  email: '',
};

export const mapStateToProps = reduxStore => ({
  customerGuid: customerGuidSelector(reduxStore),
  email: emailSelector(reduxStore),
  accessToken: accessTokenSelector(reduxStore),
});

export const mapDispatchToProps = {
  dispatchZendeskLoaded: zendeskLoaded,
  dispatchZendeskLoginUser: zendeskLoginUser,
};

export { NISOZendesk };

export default connect(mapStateToProps, mapDispatchToProps)(NISOZendesk);
